module.exports = __webpack_public_path__ + "static/media/great.e832f889.png";